import React from "react";
import {useKeycloak} from "@react-keycloak/web";
import "./login.css";
import {Navigate} from "react-router-dom";

const Login = () => {
    const {keycloak, initialized} = useKeycloak();
    const loginOptions = {redirectUri: ""};
    const token = keycloak.token;

    if (keycloak.tokenParsed != null) {
        localStorage.setItem("response", "");
        console.log(token);
        console.log("USER EMAIL: " + keycloak.tokenParsed.email);
        console.log("USER NAME: " + keycloak.tokenParsed.name);
    }

    return (//if user is loged in it will be redirected to / and if not it will get login page
        initialized && keycloak.tokenParsed == null ? <div className="login-page">
            <div className="welcome-img-parent">
                <img className="welcome-img"
                     src="/controllers-business-people-working-papers-meeting.jpeg"
                     alt="image"/>
            </div>
            <div className="login-elements-parent">
                <div className="logo-image-parent">
                    {!keycloak.authenticated && (<img className="logo-image" alt="Exela logo"
                                                      src="/xbp-logo.png"/>)}
                </div>
                <div className="login-button-parent">
                    {!keycloak.authenticated && (<button
                        type="button"
                        className="btn btn-primary login-button"
                        onClick={() => keycloak.login(loginOptions)}>Login</button>)}
                </div>
                <div className="footer">
                    <p className="footer-text">Copyright @ 2022 Exela Technologies, All rights
                        reserved.</p>
                </div>
            </div>
        </div> : <div>
            <h1>Already logged in!</h1>
            <Navigate to="/"/>
        </div>);
};

export default Login;
